import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, Layout } from "antd";
import { useNavigate } from "react-router-dom";
import "antd/dist/antd.css";
import "./Login.scss";
import MainButton from "../../components/MainButton";
import TextInput from "../../components/TextInput/TextInput";
import SubTitle from "../../components/SubTitle";
import {
  verifyLoginData,
  LoginMMRM,
  GetAuthorize,
} from "../../api/apiStore/Login/Login";
import ConfirmModal from "../../components/ConfirmModal";
import logo from "../../assets/img/img_common_form_logo_n@2x.png";
import Loading from "../../components/Loading/Loading.jsx";
import { GetCurrentTime } from "../../api/apiFunc/getDate";
import { wm_aes_decrypt_for_web } from "../../api/apiFunc/decrypt";

const { Header } = Layout;

export default function Login() {
  const [form] = Form.useForm();
  const [confirmModal, setConfirmModal] = useState({
    title: "提示",
    visible: false,
  });
  const [confirmModalMsg, setConfirmModalMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  let navigate = useNavigate();
  useEffect(() => {
    const C_NO = sessionStorage.getItem("C_NO");
    const isRegisterSucess = sessionStorage.getItem("isRegisterSucess");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const rurl = urlParams.get("rurl");
    // rurl 為 null 時不可覆寫：走完忘記密碼／註冊流程後導回的 /login 不帶 rurl，
    // 覆寫會把已存的授權網址蓋成字串 "null"，登入成功後導轉就會打到 /null 而失敗
    if (!isRegisterSucess && rurl) {
      //代表已經註冊過 不用再拿一次rurl參數
      sessionStorage.setItem("rurl", rurl);
    }
    
    if (C_NO) {
      mmrmLoginHandler({ C_NO });
    }
  }, []);

  const loginHandler = async ({ account, password }) => {
    setIsLoading(true);
    const resp = await verifyLoginData({
      account: account,
      password: password,
    });
    setIsLoading(false);
    return resp;
  };
  const fetchDataToAuthorizePage = async (memberAccessToken) => {
    setIsLoading(true);
    const resp = await GetAuthorize({ memberAccessToken });
    setIsLoading(false);
    if (resp.rcrm.RC === "C01") {
      setConfirmModal(() => {
        return {
          title: "提示",
          visible: true,
          next: `${resp.results.location}`,
        };
      });
      setConfirmModalMsg("登入成功");
    } else {
      setConfirmModal(() => {
        return { title: "提示", visible: true };
      });
      setConfirmModalMsg("請重新登入");
    }
  };
  const onFinish = () => {
    form
      .validateFields()
      .then(async (values) => {
        setIsLoading(true);
        const resp = await loginHandler({
          account: values.account,
          password: values.password,
        });
        setIsLoading(false);
        const {
          result: { Message, Data, Code },
        } = resp;
        if (Code === "0") {
          mmrmLoginHandler(Data);
        } else {
          setConfirmModal(() => {
            return { title: "提示", visible: true };
          });
          setConfirmModalMsg(Message);
        }
      })
      .catch((error) => {
        const { errorFields } = error;
        const filterErrorMsg = errorFields.map((item) => {
          const { errors } = item;
          item.errors = [...new Set(errors)];
          return item;
        });
      });
  };

  const mmrmLoginHandler = async (memberData) => {
    setIsLoading(true);
    const resp = await LoginMMRM(memberData);
    setIsLoading(false);
    if (resp.rcrm.RC === "C01") {
      sessionStorage.setItem(
        "member_access_token",
        resp.results.member_access_token
      );
      fetchDataToAuthorizePage();
    } else {
      setConfirmModal(() => {
        setConfirmModalMsg("會員取得token有誤");
        return { title: "提示", visible: true };
      });
    }
  };

  const handleOk = () => {
    if (confirmModalMsg === "登入成功") {
      window.location.replace(confirmModal.next);
    }
    setConfirmModal({ title: "提示", visible: false });
  };

  return (
    <div>
      <Loading isLoadingVisible={isLoading}></Loading>
      <Card type="inner" className="loginPage-basic">
        <SubTitle text="登入說明"></SubTitle>
        {/* <Header> */}
        <img style={{ width: "100%", height: "100%" }} src={logo} />
        {/* </Header> */}
        {/* {isErrorModalVisible ? <ErrorHandler errorList={isErrorModalVisible} /> : null} */}
        <Form
          name="basic"
          autoComplete="off"
          form={form}
          validateTrigger="onSubmit"
        >
          <Form.Item
            style={{ marginBottom: "1vh" }}
            name="account"
            rules={[
              {
                required: true,
                message: "帳號為必填",
              },
              {
                len: 10,
                message: "帳號格式錯誤",
              },
            ]}
            validateTrigger="onSubmit"
          >
            <TextInput title="帳號" values placeholder="為您的手機號碼" />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "1vh" }}
            name="password"
            rules={[
              {
                required: true,
                message: "密碼為必填",
              },
              {
                min: 6,
                message: "密碼須為 6-12 碼英數字混合",
              },
              {
                max: 12,
                message: "密碼須為 6-12 碼英數字混合",
              },
              // {
              //   pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
              //   message: "密碼須為 6-12 英數字混合",
              // },
            ]}
          >
            <TextInput
              title="密碼"
              type="shadow"
              placeholder="6 - 12 碼英數字"
            />
          </Form.Item>
          <MainButton buttonType="main" onClick={onFinish}>
            登入
          </MainButton>
        </Form>
      </Card>
      <Card type="inner" className="container-link">
        <Button
          type="link"
          className="button-link"
          onClick={() => {
            navigate("/registerFirst");
          }}
        >
          <span>會員註冊</span>
        </Button>
        <Button type="link" className="button-link">
          <span
            onClick={() => {
              navigate("/forgotPassword");
            }}
          >
            忘記密碼
          </span>
        </Button>
      </Card>
      {/* <Loading isLoadingVisible={isLoading}></Loading> */}
      {confirmModal.visible ? (
        <ConfirmModal
          title={confirmModal.title}
          setModalvisible={confirmModal.visible}
          setHandleOk={handleOk}
          msg={confirmModalMsg}
        />
      ) : null}
    </div>
  );
}
